export default __webpack_public_path__ + "static/media/thum1.78543b94.jpg";